import * as Sentry from "@sentry/browser";
import { isEmpty } from "utils/helper/common";
import { getLogRocketSessionURL, initLogRocket } from "utils/helper/logRocket";
import { initDatadog } from "utils/helper/datadog";

let logRocketSessionURL = null;

const attachLogRocketSessionURL = event => {
  if (!logRocketSessionURL) {
    return event;
  }

  return {
    ...event,
    extra: {
      ...event.extra,
      sessionURL: logRocketSessionURL
    }
  };
};

export default function setupLogService() {
  // 本番ビルドのみログ送信
  if (MODE === "production" && ENABLE_LOG_SERVICE) {
    logRocketSessionURL = null;
    initLogRocket(LOGROCKET_APP_ID, {
      network: {
        requestSanitizer: request => {
          // /auth API のパスワード入力を秘匿
          if (request.url.indexOf("/auth") !== -1) {
            const params = JSON.parse(request.body);
            Object.keys(params).forEach(key => {
              if (
                (key === "j_password" || key === "enforcePassword") &&
                !isEmpty(params[key])
              ) {
                params[key] = "*****";
              }
            });
            request.body = JSON.stringify(params);
          }
          return request;
        }
      }
    });

    // Sentry 起動
    Sentry.init({
      dsn: SENTRY_DSN,
      release: SENTRY_RELEASE,
      beforeSend: attachLogRocketSessionURL
    });

    // Sentry と LogRocket 紐づけ
    getLogRocketSessionURL(sessionURL => {
      logRocketSessionURL = sessionURL;
      Sentry.configureScope(scope => {
        scope.setExtra("sessionURL", sessionURL);
      });
    });
  }

  // Datadog は RUM も Logs も dev / stg で送信するため ENABLE_LOG_SERVICE
  // (prod のみ) とは別に判定する
  if (MODE === "production" && ENABLE_DATADOG) {
    initDatadog();
  }
}
